<template>
    <v-window v-model="windowStep" touchless>
        <v-window-item :value="'default'">
            <v-row
                class="d-flex align-center justify-center"
                no-gutters
                v-if="type === 'sendingMail'"
            >
                <v-col class="d-flex justify-center">
                    <p>
                        Les adresses Gmail et Outlook/Microsoft ne sont pas prises en charge, mais
                        arrivent bientôt sur bobbee
                    </p>
                </v-col>
            </v-row>
            <v-row
                class="d-flex align-center justify-center"
                no-gutters
                v-else-if="type === 'accountingMail' || type === 'documentFromMail'"
            >
                <v-col>
                    <v-icon size="x-small" color="error">$fa-exclamation-triangle</v-icon>
                    Les adresses Outlook/Microsoft sont temporairement bloquées, mais reviennent
                    bientôt sur bobbee
                </v-col>
            </v-row>
            <v-container fluid grid-list-md>
                <v-row no-gutters class="pa-1">
                    <v-col cols="4" v-if="type !== 'sendingMail'">
                        <v-card
                            class="pa-3 mx-5 elevation-0 rounded-xl"
                            style="
                                border: 1px #ededed solid;
                                background-color: #fff;
                                overflow: hidden;
                            "
                            @click="connectToGmail()"
                        >
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex justify-center py-2">
                                    <div
                                        style="
                                            height: 80px;
                                            width: 80px;
                                            border-radius: 80px;
                                            background-color: rgba(249, 177, 42, 0.32);
                                        "
                                        class="elevation-0 d-flex align-center justify-center"
                                    >
                                        <v-img contain height="40px" :src="GMailImg" />
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="d-flex justify-center text-center text-subtitle-1"
                                >
                                    Ajouter une adresse Gmail
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card
                            class="pa-3 mx-5 elevation-0 rounded-xl"
                            style="
                                border: 1px #ededed solid;
                                background-color: #fff;
                                overflow: hidden;
                            "
                            @click="windowStep = 'notGmailVue'"
                        >
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex justify-center py-2">
                                    <div
                                        style="
                                            height: 80px;
                                            width: 80px;
                                            border-radius: 80px;
                                            background-color: rgba(249, 177, 42, 0.32);
                                        "
                                        class="elevation-0 d-flex align-center justify-center"
                                    >
                                        <v-icon
                                            icon="$fa-envelope"
                                            color="primary"
                                            size="x-large"
                                        />
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="d-flex justify-center text-center text-subtitle-1"
                                >
                                    {{ displayTextForAddingOtherEmailAddress }}
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-window-item>
        <v-window-item :value="'notGmailVue'">
            <v-row
                class="d-flex align-center justify-center"
                no-gutters
                v-if="type === 'sendingMail'"
            >
                <v-col class="d-flex justify-center">
                    <p>
                        Les adresses Gmail ne sont pas prises en charge, mais arrivent bientôt sur
                        bobbee
                    </p>
                </v-col>
            </v-row>
            <v-card class="default_card large mx-0 pa-2" elevation="0">
                <v-form
                    ref="form"
                    v-model="valid"
                    :update:modelValue="$emit('displayValid', valid)"
                >
                    <v-row no-gutters>
                        <v-col class="d-flex pr-1" cols="12" sm="7">
                            <v-text-field-filled
                                v-model="email"
                                type="text"
                                label="Email"
                                :hide-details="false"
                                :rules="[rules.isEmail, rules.notAlreadyUsedMail, rules.notEmpty]"
                                @change="adaptHostToEmail()"
                            />
                        </v-col>
                        <v-col class="d-flex pr-1" cols="12" sm="5">
                            <v-combobox-filled
                                v-model="host"
                                :items="type === 'sendingMail' ? listHostsSmtp : listHostsImap"
                                :label="type === 'sendingMail' ? 'Serveur SMTP' : 'Serveur IMAP'"
                                :rules="[rules.notEmpty]"
                                :disabled="hostDisabled"
                                density="compact"
                            />
                            <v-btn-icon icon="$oss-edit" @click="hostDisabled = !hostDisabled" />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="d-flex pr-1" cols="12" sm="7">
                            <v-text-field-filled
                                v-model="password"
                                append-inner-icon="$oss-eye"
                                :type="show ? 'text' : 'password'"
                                label="Mot de Passe"
                                :rules="[rules.notEmpty]"
                                :hide-details="false"
                                @click:append-inner="show = !show"
                            />
                        </v-col>
                        <v-col class="d-flex pr-1" cols="12" sm="5">
                            <v-text-field-filled
                                v-model="port"
                                type="text"
                                label="Port"
                                :rules="[rules.notEmpty]"
                                :disabled="portDisabled"
                                :hide-details="false"
                            />
                            <v-btn-icon icon="$oss-edit" @click="portDisabled = !portDisabled" />
                        </v-col>
                    </v-row>
                </v-form>
                <v-alert
                    v-if="errorCredentials"
                    border="start"
                    color="red"
                    type="error"
                    variant="text"
                >
                    <div>Adresse mail, mot de passe ou serveur IMAP incorrect</div>
                    <span class="font-italic" style="font-size: 0.65em">
                        {{ formatedSpecialErrorMessage }}
                    </span>
                </v-alert>
                <v-alert
                    v-if="errorCredentials2"
                    border="start"
                    color="red"
                    type="error"
                    variant="text"
                >
                    Adresse mail incorrecte
                </v-alert>
            </v-card>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import { AccountingConfigAPIBase } from "../../../admin/AccountingConfigAPIBase";
import { Component, Vue, toNative } from "vue-facing-decorator";

const GMailImg = require("../../../../assets/img/settings-icons/gmail.png");

@Component
export class SettingsRegisterMail extends AccountingConfigAPIBase {
    get GMailImg() {
        return GMailImg;
    }

    get displayTextForAddingOtherEmailAddress() {
        return this.type === "sendingMail"
            ? "Ajouter une adresse mail (SMTP)"
            : "Ajouter une autre adresse mail";
    }

    href = "";
    get formatedSpecialErrorMessage() {
        if (this.specialErrorMessage.includes('<a href="')) {
            // this.href = this.specialErrorMessage.match(/href="([^"]*)/)[1]
            // return this.formatedSpecialErrorMessage.replace('<a href="' + this.href + '"')
        }
        return this.specialErrorMessage;
    }

    connectToGmail() {
        if (this.mailUsage == "accountingMail") {
            this.connectToAccountingMail();
        } else if (this.type === "documentFromMail") {
            this.connectToDocumentFromMail();
        } else {
            debugger;
        }
        this.type = "";
    }
}

export default toNative(SettingsRegisterMail);
</script>
